import { useFetch } from '../../hooks/useFetch';
import { resendMfa } from '../../constants';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';

const ResendMfa = ({
  phone,
  setReSecret,
  isWhatsApp
}: {
  phone: string;
  setReSecret: React.Dispatch<React.SetStateAction<string | null>>;
  isWhatsApp: boolean;
}) => {
  const { loading, fetchData, data } = useFetch();

  const resentMsg = () => {
    fetchData({ method: 'POST', url: resendMfa, data: { isWhatsApp, phone } });
  };

  useEffect(() => {
    if (data) {
      setReSecret(data.secret);
    }
  }, [data]);

  return loading ? (
    <CircularProgress size={25} color="inherit" />
  ) : (
    <Typography sx={{ marginTop: 0 }} component="h1" variant="subtitle2" color="primary">
      לקבלת קוד אחר{' '}
      <Link
        onClick={() => {
          resentMsg();
        }}
        color="text.disabled"
      >
        לחץ כאן
      </Link>
    </Typography>
  );
};

export default ResendMfa;
